<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="receivingListData"
      :auto-resize="true"
      align="center"
      :filter-config="{remote: true}"
      :footer-method="footerMethod"
      @filter-change="filterTypeMethod"
    >
      <vxe-table-column type="seq" title="序号" width="100">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{$rowIndex + 1}}</span>
          <Dropdown trigger="click" style="margin-left: 20px;" transfer>
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left:70px;">
              <div style="display: flex;flex-direction: column;">
                <Button class="button-gengduo" @click="confirmEvent(row)">移除结算信息</Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="receiveNum" title="结算确认编号" min-width="150">
        <template slot-scope="{ row }">
          <span
            @click="openReceivingDeail(row)"
            style="cursor:pointer;color: #2d8cf0;"
          >{{ row.receiveNum }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="addTime" title="结算时间" min-width="100"></vxe-table-column>
      <vxe-table-column
        field="receiveType"
        title="结算类型"
        min-width="120"
        :filters="[{label: '托运人', value: '1' ,checked: true}, {label: '承运人', value: '2'},{label: '实际承运人', value: '3'}]"
        :filter-multiple="false"
      >
        <template slot-scope="{ row }">
          <span>{{ row.receiveType | receiveTypeRule}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsName" title="货品名称" min-width="100"></vxe-table-column>
      <vxe-table-column field="goodsRule" title="规格" min-width="100"></vxe-table-column>
      <vxe-table-column field="goodsUnit" title="单位" min-width="100"></vxe-table-column>
      <vxe-table-column field="counts" title="实际交接数量" min-width="120"></vxe-table-column>
      <vxe-table-column field="price" title="单价(元)" min-width="100"></vxe-table-column>
      <vxe-table-column field="receAmount" title="结算金额(元)" min-width="100">
        <template slot-scope="{ row }">
          <span>{{row.receAmount | formatMoney}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="note" title="摘要" min-width="100"></vxe-table-column>
    </vxe-table>
    <vxe-modal
      v-model="receivingDeailModal"
      width="1300"
       height="700"
      position="center"
      title="托运人货物交接结算确认"
      showFooter
      @closeRec="closeRec"
    >
      <p slot="title" class="box-tit-211130">
        <span>托运人货物交接结算确认</span>
      </p>
      <buyer-receiving-detail ref="receivingDetail"></buyer-receiving-detail>
      <div slot="footer">
        <vxe-button
          type="submit"
          status="primary"
          @click="editReceiving(editRows,1)"
          v-if="isHavePermission('receiving:updateBuyerReceiveGoods')"
          style="width:140px;border-radius: 0px;"
        >编辑</vxe-button>
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="sellerReceivingDeailModal"
      width="1300"
      height="700"
      position="center"
      title="承运人货物交接结算确认"
      showFooter
      @closeRec="closeRec"
    >
      <p slot="title" class="box-tit-211130">
        <span>承运人货物交接结算确认</span>
      </p>
      <seller-receiving-detail ref="sellerReceivingDetail"></seller-receiving-detail>
      <div slot="footer">
        <vxe-button
          type="submit"
          status="primary"
          @click="editReceiving(editRows,2)"
           v-if="isHavePermission('receiving:updateSellerReceiveGoods')"

          style="width:140px;border-radius: 0px;"
        >编辑</vxe-button>
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="secondReceivingDeailModal"
      width="1300"
       height="700"
      position="center"
      title="实际承运人货物交接结算确认"
      showFooter
      @closeRec="closeRec"
    >
      <p slot="title" class="box-tit-211130">
        <span>实际承运人货物交接结算确认</span>
      </p>
      <second-receiving-detail ref="secondReceivingDetail"></second-receiving-detail>
      <div slot="footer">
        <vxe-button
          type="submit"
          status="primary"
          v-if="isHavePermission('receiving:updateSellerLv2ReceiveGoods')"
          @click="editReceiving(editRows,3)"
          style="width:140px;border-radius: 0px;"
        >编辑</vxe-button>
      </div>
    </vxe-modal>
    <edit-seller-receiving ref="editSellerReceiving" @updateList="updateList"></edit-seller-receiving>
    <edit-sec-receiving ref="editSecReceiving" @updateList="updateList"></edit-sec-receiving>
    <edit-buyer-receiving ref="editBuyerReceiving" @updateList="updateList"></edit-buyer-receiving>
    <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { numberToCurrency } from "@/filters/type";
import BuyerReceivingDetail from "@/views/receiving/BuyerReceivingDetail";
import SellerReceivingDetail from "@/views/receiving/SellerReceivingDetail";
import SecondReceivingDetail from "@/views/receiving/SecondReceivingDetail";
import EditSellerReceiving from "@/views/receiving/EditSellerReceiving";
import EditBuyerReceiving from "@/views/receiving/EditBuyerReceiving";
import EditSecReceiving from "@/views/receiving/EditSecReceiving";
import getAuthOrization from "@/mixin/getAuthOrization";

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  props: {
    id: Number,
    pageTab: String
  },
  components: {
    SellerReceivingDetail,
    SecondReceivingDetail,

    BuyerReceivingDetail,
    EditSecReceiving,
    EditBuyerReceiving,
    EditSellerReceiving,
  },
  mixins: [getAuthOrization],

  data() {
    return {
      loading: false,
      editRows: {},
      sellerReceivingDeailModal: false,
      receivingDeailModal: false,
      secondReceivingDeailModal: false,
      receivingListData: [],
      receiveType: 1,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      amount: {
        totalRealCounts: 0,
        totalReceAmount: 0,
      },
    };
  },
  filters: {
    receiveTypeRule(p) {
      if (p == 1) {
        return "托运人结算信息";
      } else if (p == 2) {
        return "承运人结算信息";
      } else if (p == 3) {
        return "实际承运人结算信息";
      }
    },
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getReceivingListData();
    //   }
    // },
     pageTab() {
        this.pageTab === "tab3" ? this.init() : ''
      }
  },
  // activated() {
  //   // this.getReceivingListData();
  //   this.$bus.$on("allOrderDetailRenovate", (data) => {
  //     data === true ? this.getReceivingListData() : "";
  //   });
  // },
  methods: {
    // filterReceiveTypeMethod() {
    //   console.log(11111);
    //   debugger
    // },
    init() {
      this.page.currentPage = 1;
      this.getReceivingListData()
    },
    async getReceivingListData() {
      this.loading = true;
      let res = await $api.receiving.request("queryAllReceiveGoodsListSelect", {
        chainId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        isDesc: 1,
        receiveType: this.receiveType,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.amount.totalRealCounts = res.data.countRtnVo.totalRealCounts;
        this.amount.totalReceAmount = res.data.countRtnVo.totalReceAmount;
        let receivingListData = res.data.rows;
        receivingListData.map((i) => {
          i.addTime = timeFormatDate(i.addTime);
          i.price = numberToCurrency(i.price);
          // i.receAmount = numberToCurrency(i.receAmount);
        });
        this.receivingListData = receivingListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async confirmEvent(row) {
      let res;
      let id = row.id;
      let that = this;
      let receiveType = row.receiveType;
      if (receiveType === 1) {
        res = await $api.receiving.request("queryBuyerReceiveGoodsDetail", {
          id,
        });
      } else if (receiveType === 2) {
        res = await $api.receiving.request("querySellerReceiveGoodsDetail", {
          id,
        });
      } else if (receiveType === 3) {
        res = await $api.receiving.request("querySellerLv2ReceiveGoodsDetail", {
          id,
        });
      }
      this.$XModal
        .confirm("删除后，将解除此订单关联的结算信息", "是否删除此结算信息？")
        .then((type) => {
          // this.$XModal.message({ message: `点击了 ${type}` });
          if (type === "confirm") {
            if (res.status === 1) {
              let resdata = {};
              resdata = res.data;
              resdata.logisticsList = [];
              resdata.ordersBuyerId = null;
              resdata.ordersSellerLv2Id = null;
              resdata.ordersSellerId = null;
              let fileList = [];
              if (resdata.fileList != null) {
                resdata.fileList.map((i) => {
                  fileList.push(i.uuid);
                });
                resdata.fileUuidList = fileList;
              }
              this.removeReceive(resdata, receiveType);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          }
        });
    },
    editReceiving(row, type) {
      this.receivingDeailModal = false;
      if (type == 1) {
        this.$refs.editBuyerReceiving.editReceiving(row);
      }
      if (type == 2) {
        this.$refs.editSellerReceiving.editReceiving(row);
      }
      if (type == 3) {
        this.$refs.editSecReceiving.editReceiving(row);
      }
    },
    openReceivingDeail(row) {
      this.editRows = row;
      let receiveType = row.receiveType;
      if (receiveType === 1) {
        if (!this.isHavePermission('buyer:ReceDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.receivingDeailModal = true;
        this.$refs.receivingDetail.getReceivingDetail(row);
      } else if (receiveType === 2) {
        if (!this.isHavePermission('seller:ReceDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.sellerReceivingDeailModal = true;
        // this.getReceivingDetail(row);
        this.$refs.sellerReceivingDetail.getReceivingDetail(row);
      } else if (receiveType === 3) {
        if (!this.isHavePermission('sellerLv2:ReceDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.secondReceivingDeailModal = true;
        // this.getReceivingDetail(row);
        this.$refs.secondReceivingDetail.getReceivingDetail(row);
      }
    },

    async removeReceive(resdata, receiveType) {
      let res;
      if (receiveType === 1) {
        res = await $api.receiving.request("updateBuyerReceiveGoods", resdata);
      } else if (receiveType === 2) {
        res = await $api.receiving.request("updateSellerReceiveGoods", resdata);
      } else if (receiveType === 3) {
        res = await $api.receiving.request(
          "updateSellerLv2ReceiveGoods",
          resdata
        );
      }
      if (res.status === 1) {
        this.$XModal.message({ message: `删除成功！` });
        this.getReceivingListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    updateList(val) {
      if (val) {
        this.receivingDeailModal = false;
        this.sellerReceivingDeailModal = false;
        this.secondReceivingDeailModal = false;
        this.getReceivingListData();
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getReceivingListData();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "单页合计";
          }
          if (["counts"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          if (["receAmount"].includes(column.property)) {
            return numberToCurrency(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "全部合计";
          }
          if (["counts"].includes(column.property)) {
            return this.amount.totalRealCounts;
          }

          if (["receAmount"].includes(column.property)) {
            return numberToCurrency(this.amount.totalReceAmount);
          }
          return null;
        }),
      ];
    },
    closeRec(val) {
      this.receivingDeailModal = val;
      this.sellerReceivingDeailModal = val;
      this.secondReceivingDeailModal = val;
    },
    filterTypeMethod({ column, property, values, datas, filters, $event }) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        this.receiveType = values[0];
      } else {
        this.receiveType = null;
      }
      this.getReceivingListData();
    },
  },
};
</script>

<style>
</style>